var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.727 232.727C319.993 232.727 372.091 180.629 372.091 116.364C372.091 52.0978 319.993 0 255.727 0C191.461 0 139.364 52.0978 139.364 116.364C139.364 180.629 191.461 232.727 255.727 232.727Z",
    fill: "#166DBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.014 412.393L255.727 282.997L212.44 412.393V412.626L255.727 455.913L299.014 412.626V412.393Z",
    fill: "#FF4755"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.273 256H295.756L347.189 410.065C348.867 414.338 349.276 419.004 348.368 423.504C347.46 428.003 345.273 432.145 342.069 435.433L265.502 512H465.182C471.348 511.982 477.257 509.524 481.618 505.163C485.978 500.803 488.436 494.894 488.455 488.727V442.182C488.393 392.822 468.758 345.502 433.855 310.599C398.953 275.697 351.632 256.062 302.273 256ZM169.385 435.433C166.182 432.145 163.995 428.003 163.087 423.504C162.178 419.004 162.588 414.338 164.265 410.065L215.698 256H209.182C159.822 256.062 112.502 275.697 77.5994 310.599C42.6969 345.502 23.0616 392.822 23 442.182V488.727C23.0184 494.894 25.4763 500.803 29.8368 505.163C34.1973 509.524 40.1061 511.982 46.2727 512H246.185C246.185 512 231.291 497.338 169.385 435.433Z",
    fill: "#166DBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.94d4985796dc253c3173c2d9a3cf6a11.svg";
export { ForwardRef as ReactComponent };